<template>
  <div
    id="app"
    class="wrapper "
    v-bind:class="[isAuthenticated ? 'wrapper_po' : 'wrapper_po-login',]"
  >
    <header class="po-header" v-if="isAuthenticated">
      <div class="po-header__container">
          <router-link :to="{ name: 'home'}"><img src="./assets/img/logo.svg" alt="logo"></router-link>
          <div class="po-header__menu _menu">
              <a
                class="po-header__backlink"
                v-bind:href="mainSiteURL"
              >
                  <svg class="svg-arrow-left-dims">
                      <use xlink:href="./assets/img/svg/sprite-symbol.svg#arrow-left"></use>
                  </svg>
                  Вернуться на сайт</a>
              <ul class="po-header__menu-list">
                  <li @click="closeMenu"><router-link :to="{ name: 'home'}" class="po-header__menu-item">Заказы</router-link></li>
                  <li @click="closeMenu"><router-link :to="{ name: 'profile', params: { id: user.user_id }}" class="po-header__menu-item">Мой профиль</router-link></li>
                  <li @click="closeMenu"><a href="#" class="po-header__menu-item" @click="logout">Выйти</a></li>
              </ul>
              <div class="po-header__phone" v-if="config" v-html="config.phone"></div>
              <div class="m-menu__close-btn"></div>
          </div>
          <div class="burger-btn burger-btn_po">
              <svg class="svg-burger-dims">
                  <use xlink:href="./assets/img/svg/sprite-symbol.svg#burger"></use>
              </svg>
          </div>
      </div>
    </header>
    <div class="po__phone" v-else-if="config" v-html="config.phone"></div>
    <router-view/>
    <div class="mask"></div>
  </div>
</template>
<script>

import $ from 'jquery';

import { Config } from '@/api/config';

export default {
  name: 'App',
  computed: {
    isAuthenticated: function() {
      return this.$store.getters.isAuthenticated;
    },
    user: function() {
      return this.$store.getters.user;
    }
  },
  data: function() {
    return {
      config: null,
      mainSiteURL: process.env.VUE_APP_MAIN_SITE_URL
    }
  },
  methods: {
    logout: function() {
      this.$store.commit('removeToken');
      this.$router.go({name: 'login'});
    },
    closeMenu: function() {
      $('.mask').fadeOut(500);
      $('._menu').removeClass('m-menu_opened');
    }
  },
  mounted() {
    var mask = $('.mask'),
    menuBtn = $('.burger-btn'),
    menu = $('._menu'),
    closeBtn = $('.m-menu__close-btn');

    menuBtn.on('click', function () {
        mask.fadeIn(500);
        menu.addClass('m-menu_opened');
    });

    closeBtn.on('click', function () {
        mask.fadeOut(500);
        menu.removeClass('m-menu_opened');
    });
    Config.get(this.$route.params.id).then(response => {
        this.config = response.data;
    });
  }
}
</script>
<style lang="scss">
  .wrapper_po-login {
    background-image: url('./assets/img/bg-login.jpg')
  }
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  // .slide-fade-leave-active {
  //   // transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  //   transition: all .1s ease;
  // }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active до версии 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }

</style>